import i18next from 'i18next';
import en from './i18n/en';
import termsAndConditionConfig from './terms-and-condition/terms-and-condition-config';
import privacyPolicyConfig from './privacy-policy/privacy-policy-config';
import unsubscribeConfig from './unsubscribe/unsubscribe-config';
import ticketConfig from './ticket/ticket-config';
import faqConfig from './faq/faq-config';

i18next.addResourceBundle('en', 'public', en);

const publicConfigs = [faqConfig, termsAndConditionConfig, privacyPolicyConfig, ticketConfig, unsubscribeConfig];

export default publicConfigs;